import LongRectangleTextButton from 'components/atoms/longRectangleTextButton';
import ProfileNameAndPhoto from 'components/atoms/profileNameAndPhoto';
import ProfileList from 'components/molecules/profileList';
import {useUserStore} from 'contexts/StoreContext';
import {useTheme} from 'contexts/ThemeContext';
import {ProfileScreenProps} from 'navigations/ProfileFlow';
import {Flows, ScreenName} from 'navigations/Screens';
import React from 'react';
import styleSheet from './styles';
import {observer} from 'mobx-react';

const ProfileScreen = observer((props: ProfileScreenProps) => {
  const theme = useTheme();
  const styles = styleSheet(theme);

  return <></>;
});

export default ProfileScreen;
